// extracted by mini-css-extract-plugin
export default {"container":"Reports_container__7v6Zx","content":"Reports_content__b25cd","tabsContainer":"Reports_tabsContainer__yTJFu"};